var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "user_Background_",
    "data-name": "user (Background)",
    width: 40,
    height: 40,
    rx: 20,
    fill: "#45b26b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Stop_Line",
    "data-name": "icons/Stop/Line",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10,20a41.821,41.821,0,0,1-5.458-.369A4.8,4.8,0,0,1,.369,15.458,41.8,41.8,0,0,1,0,10,41.821,41.821,0,0,1,.369,4.541,4.8,4.8,0,0,1,4.541.369,41.821,41.821,0,0,1,10,0a41.8,41.8,0,0,1,5.458.369,4.8,4.8,0,0,1,4.172,4.172A41.821,41.821,0,0,1,20,10a41.8,41.8,0,0,1-.369,5.458,4.8,4.8,0,0,1-4.172,4.172A41.8,41.8,0,0,1,10,20ZM10,2a39.859,39.859,0,0,0-5.2.352A2.819,2.819,0,0,0,2.352,4.8,39.859,39.859,0,0,0,2,10a39.859,39.859,0,0,0,.352,5.2A2.819,2.819,0,0,0,4.8,17.648,39.859,39.859,0,0,0,10,18a39.859,39.859,0,0,0,5.2-.352A2.819,2.819,0,0,0,17.648,15.2,39.859,39.859,0,0,0,18,10a39.859,39.859,0,0,0-.352-5.2A2.819,2.819,0,0,0,15.2,2.352,39.859,39.859,0,0,0,10,2Z",
    transform: "translate(0 0)",
    fill: "#fcfcfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSquare);
export default __webpack_public_path__ + "static/media/greenSquare.04174c74e2ae14a89084b9a33faf8fba.svg";
export { ForwardRef as ReactComponent };